// extracted by mini-css-extract-plugin
module.exports = {"body":"BackInStockBody_body__4hAmr","name":"BackInStockBody_name___oMMh","subtitle":"BackInStockBody_subtitle__PJRUT","formWrapper":"BackInStockBody_formWrapper__UvPnO"};